import { ScreenWrapper } from '@south-street-app/molecules';
import { useChatStore } from '@south-street-app/stores';

import { UpdatesConversationContent } from './UpdatesConversationContent';

const UpdatesChatScreen = () => {
  const updatesConversation = useChatStore((state) => state.updatesConversation);

  return (
    <ScreenWrapper>
      <UpdatesConversationContent conversation={updatesConversation} />
    </ScreenWrapper>
  );
};

export { UpdatesChatScreen };
